<template>
  <div id="pubTable" v-if="CommentList.length">
    <div class="pubTitle"><i></i>评语</div>
    <div class="PYlist" v-for="(item,index) in CommentList" :key="index">
      <div class="top_list"> {{ item.level_name }}-{{item.real_name}}-{{ item.created_at }}</div>
      <div class="bottom_list">{{ item.content }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  props:['CommentList'],
}
</script>
<style scoped>
.PYlist{
  padding-left: 10px;
  font-size: 15px;
}
.PYlist .bottom_list{
  padding-left: 30px;
  line-height: 30px;
  color: #919399;
}
</style>